export const theme = {
  breakpoints: {
    xs: '(min-width: 400px)',
    sm: '(min-width: 600px)',
    md: '(min-width: 1024px)',
    lg: '(min-width: 1200px)',
    xl: '(min-width: 1300px)',
    '2xl': '(min-width: 1630px)',
  },
  colors: {
    primary: {
      main: '#003686',
      light: '#E7F0F8',
    },
    secondary: {
      main: '#6FBA2C',
      light: '#E9F5DF',
    },
    red: {
      main: '#D02C2C',
    },
    gray: {
      darker: '#2B2A2A',
      dark: '#4E4E4E',
      main: '#707070',
      light: '#B3B3B3',
      lighter: '#F2F2F2',
    },
    white: '#FFF',
    black: '#323333',
  },
  fonts: {
    default:
      "'YuGothic','Yu Gothic','Hiragino Kaku Gothic ProN','ヒラギノ角ゴ ProN W3','メイリオ', 'Meiryo','ＭＳ ゴシック',sans-serif",
    roboto: "'Roboto', sans-serif",
    josefinSans: "'Josefin Sans', sans-serif",
  },
  fontSizes: {
    heading1: '5.5rem',
    heading2: '4.5rem',
    heading3: '3.8rem',
    heading4: '3rem',
    heading5: '2.6rem',
    heading6: '2.2rem',
    heading7: '2rem',
    body0: '2.3rem',
    body1: '2.1rem',
    body2: '1.8rem',
    body3: '1.6rem',
  },
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  letterSpacings: {
    ultratight: '0.02em',
    tighter: '0.05em',
    tight: '0.08em',
    normal: '0.1em',
    relaxed: '0.12em',
    wide: '0.15em',
  },
  lineHeight: {
    tighter: '1.1',
    tight: '1.3',
    normal: '1.5',
    relaxed: '1.75',
    loose: '2',
  },
}

export type Theme = typeof theme
